/**
 * VITALGLOW Shopify Theme JavaScript
 * Handles FAQ accordion, mobile menu, and search toggle
 */

document.addEventListener('DOMContentLoaded', function() {
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Add to cart animation feedback
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) {
        var originalText = btn.innerHTML;
        btn.innerHTML = '<svg class="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg> Adding...';
        setTimeout(function() {
          btn.innerHTML = '✓ Added to Cart!';
          setTimeout(function() {
            btn.innerHTML = originalText;
          }, 2000);
        }, 800);
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.grid.grid-cols-4').forEach(function (thumbGrid) {
    var gallery = thumbGrid.parentElement;
    if (!gallery) return;

    var mainImg = gallery.querySelector('div:first-child img');
    var thumbs = thumbGrid.querySelectorAll('img');

    if (!mainImg || thumbs.length === 0) return;

    thumbs.forEach(function (thumb) {
      var thumbBox = thumb.closest('div');
      if (!thumbBox) return;

      thumbBox.setAttribute('role', 'button');
      thumbBox.setAttribute('tabindex', '0');

      function switchImage() {
        var thumbSrc = thumb.getAttribute('src');
        if (!thumbSrc) return;

        var largeSrc = thumbSrc
          .replace(/_150x(\.[a-zA-Z0-9]+)(\?v=)/, '_900x$1$2')
          .replace(/_150x(\.[a-zA-Z0-9]+)$/, '_900x$1');

        mainImg.setAttribute('src', largeSrc);
        mainImg.setAttribute('alt', thumb.getAttribute('alt') || mainImg.getAttribute('alt') || '');

        thumbs.forEach(function (item) {
          var box = item.closest('div');
          if (!box) return;
          box.style.borderColor = '#e5e7eb';
          box.style.boxShadow = 'none';
        });

        thumbBox.style.borderColor = '#1B4D8E';
        thumbBox.style.boxShadow = '0 0 0 2px rgba(27, 77, 142, 0.22)';
      }

      thumbBox.addEventListener('click', switchImage);

      thumbBox.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          switchImage();
        }
      });
    });
  });
});